import { PartBalanceService } from "@common/client"
import { partStockBaseKey } from "./part-stock"
import { makeAxiosMutation, makeQuery } from "./utils"

const PART_BALANCE_PAGE_SIZE = 500

export const partBalancesBaseKey = ["part-balances"] as const

export const partBalancesKey = (partId: string) =>
  [...partBalancesBaseKey, "list", partId] as const

export const partBalancesQuery = makeQuery({
  serviceCall: (partId: string) =>
    PartBalanceService.listBalances({
      part_id: partId,
      limit: PART_BALANCE_PAGE_SIZE,
    }),
  queryKey: partBalancesKey,
})

export const useCreatePartBalanceMutation = makeAxiosMutation({
  serviceCall: PartBalanceService.create,
  invalidates: () => [partBalancesBaseKey, partStockBaseKey],
})

const FITTABLE_STOCK_PAGE_SIZE = 20

export const fittableStockKey = (search: string) =>
  [...partBalancesBaseKey, "fittable", search] as const

export const fittableStockQuery = makeQuery({
  serviceCall: (search: string) =>
    PartBalanceService.listBalances({
      search: search || undefined,
      fittable_only: true,
      limit: FITTABLE_STOCK_PAGE_SIZE,
    }),
  queryKey: fittableStockKey,
})
